import { ChatComponentProps } from '../../types/chat/type'
import { MessageLeft, MessageRight } from '../message/Message'
import { TextInput } from '../message/TextFiled'

function ChatComponent({
  messages,
  message,
  setMessage,
  sendMessage,
}: ChatComponentProps) {
  return (
    <div className="h-full w-[40vw] bg-white shadow-md">
      <div className="m-2.5 h-[calc(100%-80px)] overflow-y-scroll">
        {messages.map((msg, index) =>
          msg.sender === 'あなた' ? (
            <MessageRight key={index} message={msg.text} />
          ) : (
            <MessageLeft key={index} message={msg.text} />
          )
        )}
      </div>
      <TextInput
        sendMessage={sendMessage}
        setMessage={setMessage}
        message={message}
      />
    </div>
  )
}

export default ChatComponent
